// @flow
import {
  ADMIN_GET_LICENCE_LIST,
  ADMIN_UPDATE_LICENCE_ITEM,
  ADMIN_DELETE_LICENCE_ITEM,
  ADMIN_LICENCE_UPDATE_ITEM
} from "../../global/actions/actionNames";

const initialState = {
  licences: null
};

const licenceReducers = (state: Object = initialState, actions: Object): * => {
  switch (actions.type) {
    case ADMIN_GET_LICENCE_LIST:
      if (actions.licences !== null) {
        const licences = actions.licences;
        return {
          ...state,
          licences: licences
        };
      }
      return state;

    case ADMIN_UPDATE_LICENCE_ITEM:
      if (actions.data !== null && actions.data.id !== null && state.licences) {
        let licences = [...state.licences];
        if (licences.length > 0) {
          let index = licences.findIndex(x => x.id === actions.data.id);
          if (index > -1) {
            licences[index] = actions.data;
          } else {
            licences.push(actions.data);
          }
        } else {
          licences.push(actions.data);
        }
        return {
          ...state,
          licences: licences
        };
      }
      return state;

    case ADMIN_DELETE_LICENCE_ITEM:
      if (actions.licenceid !== null && state.licences) {
        let licences = [...state.licences];
        if (licences.length > 0) {
          let index = licences.findIndex(x => x.id === actions.licenceid);
          if (index > -1) {
            licences.splice(index, 1);
          }
        }
        return {
          ...state,
          licences: licences
        };
      }
      return state;

    case ADMIN_LICENCE_UPDATE_ITEM:
      if (
        actions.value !== undefined &&
        actions.licenceId !== undefined &&
        actions.fieldName !== undefined
      ) {
        let licences = [...state.licences];
        if (licences.length > 0) {
          let index = licences.findIndex(x => x.id === actions.licenceId);
          if (index > -1) {
            let licence = { ...licences[index] };
            licence[actions.fieldName] = actions.value;
            licences[index] = { ...licence };

            return {
              ...state,
              licences: licences
            };
          }
        }
      }
      return state;

    default:
      return state;
  }
};
export default licenceReducers;
